var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.835 5.342L14.66 4.167 10 8.825 5.343 4.167 4.168 5.342 8.826 10l-4.658 4.658 1.175 1.175 4.658-4.658 4.659 4.658 1.175-1.175L11.176 10l4.659-4.658z",
    fill: "currentColor"
  })));
}
export default SvgClose;